// extracted by mini-css-extract-plugin
export var container = "_b7-1";
export var cornerButtonContainer = "_b7-6";
export var disabled = "_b7-2";
export var dragActive = "_b7-3";
export var fileContainer = "_b7-5";
export var hiddenInput = "_b7-4";
export var widthContainer = "_b7-0";